(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iQuXN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $19a1e240c70a99c0$export$2e2bcd8739ae039; });
/* language-selector.tsx generated by @compiled/babel-plugin v0.28.2 */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $amul4 = parcelRequire("amul4");

var $1Mpn7 = parcelRequire("1Mpn7");

var $2vwrh = parcelRequire("2vwrh");

var $8pPrt = parcelRequire("8pPrt");

var $bOy9g = parcelRequire("bOy9g");
var $bIfY9 = parcelRequire("bIfY9");

var $j33pI = parcelRequire("j33pI");

var $idnzS = parcelRequire("idnzS");

var $eZ1WC = parcelRequire("eZ1WC");
/**
 * Custom React-Select's Control component to allow adding the globe icon.
 */ var $19a1e240c70a99c0$var$Control = function(_param) {
    var children = _param.children, props = (0, $dRLPW._)(_param, [
        "children"
    ]);
    // @ts-ignore
    var isMouseOver = props.selectProps.isMouseOver;
    return /*#__PURE__*/ (0, $amul4.jsxs)((0, $bOy9g.c).Control, (0, $cxjpp._)((0, $do9pw._)({}, props), {
        children: [
            /*#__PURE__*/ (0, $amul4.jsx)((0, $eZ1WC.LanguageGlobeIcon), {
                color: isMouseOver ? "#172b4d" : "#42526e"
            }),
            children
        ]
    }));
};
/**
 * Custom React-Select's DropdownIndicator component to update the arrow icon.
 */ var $19a1e240c70a99c0$var$DropdownIndicator = function(props) {
    return /*#__PURE__*/ (0, $amul4.jsx)((0, $bOy9g.c).DropdownIndicator, (0, $cxjpp._)((0, $do9pw._)({}, props), {
        children: "\u25BE"
    }));
};
/**
 * Styles for the LanguageSelector container div.
 */ var $19a1e240c70a99c0$var$languageSelectorContainerStyle = null;
/**
 * Global footer's language selector component.
 * Uses React-Select to render the language selector with custom styling and on mouseover behavior.
 * Dropdown menu and the options have the same styling as WPL DropdownSelector.
 *
 * @param selectedLanguage - The selected language. Defaults to 'en'.
 * @param onChangeHandler - The function to call when a different language is selected.
 * @param className - The class name to apply to the container div.
 */ var $19a1e240c70a99c0$var$LanguageSelector = function(param) {
    var _param_selectedLanguage = param.selectedLanguage, selectedLanguage = _param_selectedLanguage === void 0 ? "en" : _param_selectedLanguage, onLanguageChangeHandler = param.onLanguageChangeHandler, className = param.className, testId = param.testId;
    var intl = (0, $8pPrt.default)();
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isMouseOver = _useState[0], setMouseOver = _useState[1];
    var elementID = "language-dropdown";
    if (!onLanguageChangeHandler) onLanguageChangeHandler = function(newLocale) {
        // check if there is already a locale in the path
        var path = (0, $idnzS.parseRoute)(window.location).path;
        // exclude trailing slash in the case of the home page
        window.location.href = path.length ? "/".concat(newLocale, "/").concat(path) : "/".concat(newLocale);
    };
    var languageSelectStyle = {
        container: function(provided) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                appearance: "none",
                flexDirection: "row",
                fontSize: "0.875rem;",
                textAlign: "left"
            });
        },
        control: function(provided, state) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                color: isMouseOver ? "#172b4d" : "#42526e",
                cursor: isMouseOver ? "pointer" : "default",
                display: "inline-flex",
                border: state.isFocused ? "2px solid #4c9aff" : "2px solid transparent"
            });
        },
        valueContainer: function(provided) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                marginLeft: "var(--ds-space-050)",
                textDecorationLine: isMouseOver ? "underline" : "none"
            });
        },
        indicatorsContainer: function(provided) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                marginLeft: "var(--ds-space-050)"
            });
        },
        dropdownIndicator: function(provided) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                fontSize: "1.5rem",
                height: "40px"
            });
        },
        menu: function(provided) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                marginTop: "var(--ds-space-050)",
                boxShadow: "0px 3px 5px 0px #091E4233",
                background: "#ffffff",
                borderRadius: "var(--ds-space-050)",
                width: "5.5rem"
            });
        },
        option: function(provided, state) {
            return (0, $cxjpp._)((0, $do9pw._)({}, provided), {
                "cursor": "pointer",
                "padding": "var(--ds-space-100) var(--ds-space-100)",
                "backgroundColor": state.isSelected ? "#b2d4ff" : state.isFocused ? "#ebecf0" : "#fafbfc",
                "color": state.isSelected ? "#0065ff" : "#172b4d",
                "&:hover": {
                    background: state.isSelected ? "#b2d4ff" : "#ebecf0"
                },
                "&:active": {
                    background: "#dfe1e5"
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $amul4.jsxs)((0, $amul4.Fragment), {
        children: [
            /*#__PURE__*/ (0, $amul4.jsx)((0, $j33pI.default), {
                children: /*#__PURE__*/ (0, $amul4.jsx)("label", {
                    htmlFor: elementID,
                    children: "Language Selector"
                })
            }),
            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                className: (0, $2vwrh.default)([
                    "_1e0c116y",
                    className
                ]),
                "data-testid": testId,
                onMouseEnter: function() {
                    return setMouseOver(true);
                },
                onMouseLeave: function() {
                    return setMouseOver(false);
                },
                children: /*#__PURE__*/ (0, $amul4.jsx)((0, $bIfY9.default), {
                    inputId: elementID,
                    defaultValue: (0, $eZ1WC.languages).find(function(language) {
                        return language.value === selectedLanguage;
                    }),
                    options: (0, $eZ1WC.languages),
                    onChange: function(selectedOption) {
                        selectedOption && selectedOption.value !== selectedLanguage && (onLanguageChangeHandler === null || onLanguageChangeHandler === void 0 ? void 0 : onLanguageChangeHandler(selectedOption.value));
                    },
                    unstyled: true,
                    // @ts-ignore
                    isMouseOver: isMouseOver,
                    onMenuClose: function() {
                        return setMouseOver(false);
                    },
                    "aria-label": intl.formatMessage({
                        defaultMessage: "Choose your language",
                        id: "globalFooter.bottom.language-selector"
                    }),
                    components: {
                        Control: $19a1e240c70a99c0$var$Control,
                        DropdownIndicator: $19a1e240c70a99c0$var$DropdownIndicator
                    },
                    styles: languageSelectStyle,
                    menuPlacement: "auto"
                })
            })
        ]
    });
};
var $19a1e240c70a99c0$export$2e2bcd8739ae039 = $19a1e240c70a99c0$var$LanguageSelector;

});
parcelRegister("bOy9g", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $899eda6015fcb069$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $899eda6015fcb069$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $899eda6015fcb069$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "L", function () { return $899eda6015fcb069$export$61196ced6d74a310; });
$parcel$export(module.exports, "G", function () { return $899eda6015fcb069$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $899eda6015fcb069$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $899eda6015fcb069$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $899eda6015fcb069$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $899eda6015fcb069$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $899eda6015fcb069$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $899eda6015fcb069$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $899eda6015fcb069$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $899eda6015fcb069$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $899eda6015fcb069$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $899eda6015fcb069$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $899eda6015fcb069$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $899eda6015fcb069$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $899eda6015fcb069$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $899eda6015fcb069$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $899eda6015fcb069$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $899eda6015fcb069$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $899eda6015fcb069$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $899eda6015fcb069$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $899eda6015fcb069$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $899eda6015fcb069$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $899eda6015fcb069$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $899eda6015fcb069$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $899eda6015fcb069$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $899eda6015fcb069$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $899eda6015fcb069$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $899eda6015fcb069$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $899eda6015fcb069$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $899eda6015fcb069$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $899eda6015fcb069$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $899eda6015fcb069$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $899eda6015fcb069$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $899eda6015fcb069$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $899eda6015fcb069$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $899eda6015fcb069$export$d66501df72047452; });

var $3lqla = parcelRequire("3lqla");

var $iunch = parcelRequire("iunch");

var $fBy54 = parcelRequire("fBy54");

var $i6eFW = parcelRequire("i6eFW");

var $4dmKN = parcelRequire("4dmKN");

var $iVDBw = parcelRequire("iVDBw");

var $euDes = parcelRequire("euDes");

var $68AhI = parcelRequire("68AhI");

var $1Mpn7 = parcelRequire("1Mpn7");

var $eaouD = parcelRequire("eaouD");

var $iNJcg = parcelRequire("iNJcg");

var $i2lfV = parcelRequire("i2lfV");
var $899eda6015fcb069$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $899eda6015fcb069$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $899eda6015fcb069$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $899eda6015fcb069$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($899eda6015fcb069$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $899eda6015fcb069$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($899eda6015fcb069$var$isArray(value)) return value.filter(Boolean);
    if ((0, $iVDBw.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $899eda6015fcb069$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $4dmKN.default)(props, $899eda6015fcb069$var$_excluded$4);
    return (0, $3lqla.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $899eda6015fcb069$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $899eda6015fcb069$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $899eda6015fcb069$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $899eda6015fcb069$var$normalizedHeight(el) {
    if ($899eda6015fcb069$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $899eda6015fcb069$var$getScrollTop(el) {
    if ($899eda6015fcb069$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $899eda6015fcb069$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($899eda6015fcb069$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $899eda6015fcb069$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $899eda6015fcb069$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $899eda6015fcb069$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $899eda6015fcb069$export$b4171a6734a65d42;
    var start = $899eda6015fcb069$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $899eda6015fcb069$var$easeOutCubic(currentTime, start, change, duration);
        $899eda6015fcb069$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $899eda6015fcb069$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $899eda6015fcb069$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $899eda6015fcb069$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $899eda6015fcb069$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $899eda6015fcb069$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $899eda6015fcb069$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $899eda6015fcb069$var$passiveOptionAccessed = false;
var $899eda6015fcb069$var$options = {
    get passive () {
        return $899eda6015fcb069$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $899eda6015fcb069$var$w = typeof window !== "undefined" ? window : {};
if ($899eda6015fcb069$var$w.addEventListener && $899eda6015fcb069$var$w.removeEventListener) {
    $899eda6015fcb069$var$w.addEventListener("p", $899eda6015fcb069$export$b4171a6734a65d42, $899eda6015fcb069$var$options);
    $899eda6015fcb069$var$w.removeEventListener("p", $899eda6015fcb069$export$b4171a6734a65d42, false);
}
var $899eda6015fcb069$export$2408f22a0fab9ae5 = $899eda6015fcb069$var$passiveOptionAccessed;
function $899eda6015fcb069$export$3466f893ebf79586(item) {
    return item != null;
}
function $899eda6015fcb069$var$isArray(arg) {
    return Array.isArray(arg);
}
function $899eda6015fcb069$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $899eda6015fcb069$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $899eda6015fcb069$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $899eda6015fcb069$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $i6eFW.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $i6eFW.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $899eda6015fcb069$var$_excluded$3 = [
    "children",
    "innerProps"
], $899eda6015fcb069$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $899eda6015fcb069$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $899eda6015fcb069$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $899eda6015fcb069$var$normalizedHeight(scrollParent);
    var scrollTop = $899eda6015fcb069$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $899eda6015fcb069$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $899eda6015fcb069$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $899eda6015fcb069$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $899eda6015fcb069$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $899eda6015fcb069$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $899eda6015fcb069$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $899eda6015fcb069$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $899eda6015fcb069$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $3lqla.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $68AhI.default)(_objectSpread2, $899eda6015fcb069$var$alignToControl(placement), "100%"), (0, $68AhI.default)(_objectSpread2, "position", "absolute"), (0, $68AhI.default)(_objectSpread2, "width", "100%"), (0, $68AhI.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $899eda6015fcb069$var$PortalPlacementContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(null);
// NOTE: internal only
var $899eda6015fcb069$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $1Mpn7.useContext)($899eda6015fcb069$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $1Mpn7.useRef)(null);
    var _useState = (0, $1Mpn7.useState)(maxMenuHeight), _useState2 = (0, $i6eFW.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $1Mpn7.useState)(null), _useState4 = (0, $i6eFW.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $i2lfV.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $899eda6015fcb069$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $3lqla.default)((0, $3lqla.default)({}, props), {}, {
            placement: placement || $899eda6015fcb069$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $899eda6015fcb069$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $899eda6015fcb069$var$Menu$1 = $899eda6015fcb069$var$Menu;
// ==============================
// Menu List
// ==============================
var $899eda6015fcb069$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $3lqla.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $899eda6015fcb069$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $899eda6015fcb069$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $3lqla.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $899eda6015fcb069$export$3b14a55fb2447963 = $899eda6015fcb069$var$noticeCSS;
var $899eda6015fcb069$export$342063e11d6c3cad = $899eda6015fcb069$var$noticeCSS;
var $899eda6015fcb069$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $4dmKN.default)(_ref6, $899eda6015fcb069$var$_excluded$3);
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps((0, $3lqla.default)((0, $3lqla.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $899eda6015fcb069$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $4dmKN.default)(_ref7, $899eda6015fcb069$var$_excluded2$1);
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps((0, $3lqla.default)((0, $3lqla.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $899eda6015fcb069$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $899eda6015fcb069$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $1Mpn7.useRef)(null);
    var cleanupRef = (0, $1Mpn7.useRef)(null);
    var _useState5 = (0, $1Mpn7.useState)($899eda6015fcb069$var$coercePlacement(menuPlacement)), _useState6 = (0, $i6eFW.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $1Mpn7.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $1Mpn7.useState)(null), _useState8 = (0, $i6eFW.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $1Mpn7.useCallback)(function() {
        if (!controlElement) return;
        var rect = $899eda6015fcb069$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $i2lfV.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $1Mpn7.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $iNJcg.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $i2lfV.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $1Mpn7.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $fBy54.jsx)("div", (0, $iunch.default)({
        ref: setMenuPortalElement
    }, $899eda6015fcb069$var$getStyleProps((0, $3lqla.default)((0, $3lqla.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $fBy54.jsx)($899eda6015fcb069$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $eaouD.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $899eda6015fcb069$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $899eda6015fcb069$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $899eda6015fcb069$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $3lqla.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $899eda6015fcb069$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $899eda6015fcb069$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $899eda6015fcb069$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $899eda6015fcb069$var$_templateObject;
var $899eda6015fcb069$var$_excluded$2 = [
    "size"
], $899eda6015fcb069$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $899eda6015fcb069$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $899eda6015fcb069$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $899eda6015fcb069$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $4dmKN.default)(_ref, $899eda6015fcb069$var$_excluded$2);
    return (0, $fBy54.jsx)("svg", (0, $iunch.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $899eda6015fcb069$var$_ref2
    }, props));
};
var $899eda6015fcb069$var$CrossIcon = function CrossIcon(props) {
    return (0, $fBy54.jsx)($899eda6015fcb069$var$Svg, (0, $iunch.default)({
        size: 20
    }, props), (0, $fBy54.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $899eda6015fcb069$var$DownChevron = function DownChevron(props) {
    return (0, $fBy54.jsx)($899eda6015fcb069$var$Svg, (0, $iunch.default)({
        size: 20
    }, props), (0, $fBy54.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $899eda6015fcb069$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $3lqla.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $899eda6015fcb069$export$f1e1789686576879 = $899eda6015fcb069$var$baseCSS;
var $899eda6015fcb069$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $fBy54.jsx)($899eda6015fcb069$var$DownChevron, null));
};
var $899eda6015fcb069$export$407448d2b89b1813 = $899eda6015fcb069$var$baseCSS;
var $899eda6015fcb069$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $fBy54.jsx)($899eda6015fcb069$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $899eda6015fcb069$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $3lqla.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $899eda6015fcb069$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $fBy54.jsx)("span", (0, $iunch.default)({}, innerProps, $899eda6015fcb069$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $899eda6015fcb069$var$loadingDotAnimations = (0, $fBy54.keyframes)($899eda6015fcb069$var$_templateObject || ($899eda6015fcb069$var$_templateObject = (0, $euDes.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $899eda6015fcb069$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $3lqla.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $899eda6015fcb069$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $fBy54.jsx)("span", {
        css: /*#__PURE__*/ (0, $fBy54.css)({
            animation: "".concat($899eda6015fcb069$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $899eda6015fcb069$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $4dmKN.default)(_ref7, $899eda6015fcb069$var$_excluded2);
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps((0, $3lqla.default)((0, $3lqla.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $fBy54.jsx)($899eda6015fcb069$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $fBy54.jsx)($899eda6015fcb069$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $fBy54.jsx)($899eda6015fcb069$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $899eda6015fcb069$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $3lqla.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $899eda6015fcb069$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({
        ref: innerRef
    }, $899eda6015fcb069$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $899eda6015fcb069$var$Control$1 = $899eda6015fcb069$var$Control;
var $899eda6015fcb069$var$_excluded$1 = [
    "data"
];
var $899eda6015fcb069$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $899eda6015fcb069$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $fBy54.jsx)(Heading, (0, $iunch.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $fBy54.jsx)("div", null, children));
};
var $899eda6015fcb069$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $3lqla.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $899eda6015fcb069$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $899eda6015fcb069$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $4dmKN.default)(_cleanCommonProps, $899eda6015fcb069$var$_excluded$1);
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $899eda6015fcb069$var$Group$1 = $899eda6015fcb069$var$Group;
var $899eda6015fcb069$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $899eda6015fcb069$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $3lqla.default)((0, $3lqla.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $899eda6015fcb069$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $899eda6015fcb069$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $899eda6015fcb069$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $3lqla.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $899eda6015fcb069$var$spacingStyle)
};
var $899eda6015fcb069$var$inputStyle = function inputStyle(isHidden) {
    return (0, $3lqla.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $899eda6015fcb069$var$spacingStyle);
};
var $899eda6015fcb069$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $899eda6015fcb069$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $4dmKN.default)(_cleanCommonProps, $899eda6015fcb069$var$_excluded);
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $fBy54.jsx)("input", (0, $iunch.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $899eda6015fcb069$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $899eda6015fcb069$var$Input$1 = $899eda6015fcb069$var$Input;
var $899eda6015fcb069$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $3lqla.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $899eda6015fcb069$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $3lqla.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $899eda6015fcb069$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $3lqla.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $899eda6015fcb069$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $fBy54.jsx)("div", innerProps, children);
};
var $899eda6015fcb069$var$MultiValueContainer = $899eda6015fcb069$var$MultiValueGeneric;
var $899eda6015fcb069$var$MultiValueLabel = $899eda6015fcb069$var$MultiValueGeneric;
function $899eda6015fcb069$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({
        role: "button"
    }, innerProps), children || (0, $fBy54.jsx)($899eda6015fcb069$var$CrossIcon, {
        size: 14
    }));
}
var $899eda6015fcb069$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $fBy54.jsx)(Container, {
        data: data,
        innerProps: (0, $3lqla.default)((0, $3lqla.default)({}, $899eda6015fcb069$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $fBy54.jsx)(Label, {
        data: data,
        innerProps: (0, $3lqla.default)({}, $899eda6015fcb069$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $fBy54.jsx)(Remove, {
        data: data,
        innerProps: (0, $3lqla.default)((0, $3lqla.default)({}, $899eda6015fcb069$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $899eda6015fcb069$var$MultiValue$1 = $899eda6015fcb069$var$MultiValue;
var $899eda6015fcb069$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $3lqla.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $899eda6015fcb069$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $899eda6015fcb069$var$Option$1 = $899eda6015fcb069$var$Option;
var $899eda6015fcb069$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $3lqla.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $899eda6015fcb069$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $899eda6015fcb069$var$Placeholder$1 = $899eda6015fcb069$var$Placeholder;
var $899eda6015fcb069$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $3lqla.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $899eda6015fcb069$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $fBy54.jsx)("div", (0, $iunch.default)({}, $899eda6015fcb069$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $899eda6015fcb069$var$SingleValue$1 = $899eda6015fcb069$var$SingleValue;
var $899eda6015fcb069$export$db3b6bfb95261072 = {
    ClearIndicator: $899eda6015fcb069$var$ClearIndicator,
    Control: $899eda6015fcb069$var$Control$1,
    DropdownIndicator: $899eda6015fcb069$var$DropdownIndicator,
    DownChevron: $899eda6015fcb069$var$DownChevron,
    CrossIcon: $899eda6015fcb069$var$CrossIcon,
    Group: $899eda6015fcb069$var$Group$1,
    GroupHeading: $899eda6015fcb069$var$GroupHeading,
    IndicatorsContainer: $899eda6015fcb069$var$IndicatorsContainer,
    IndicatorSeparator: $899eda6015fcb069$var$IndicatorSeparator,
    Input: $899eda6015fcb069$var$Input$1,
    LoadingIndicator: $899eda6015fcb069$var$LoadingIndicator,
    Menu: $899eda6015fcb069$var$Menu$1,
    MenuList: $899eda6015fcb069$var$MenuList,
    MenuPortal: $899eda6015fcb069$var$MenuPortal,
    LoadingMessage: $899eda6015fcb069$var$LoadingMessage,
    NoOptionsMessage: $899eda6015fcb069$var$NoOptionsMessage,
    MultiValue: $899eda6015fcb069$var$MultiValue$1,
    MultiValueContainer: $899eda6015fcb069$var$MultiValueContainer,
    MultiValueLabel: $899eda6015fcb069$var$MultiValueLabel,
    MultiValueRemove: $899eda6015fcb069$var$MultiValueRemove,
    Option: $899eda6015fcb069$var$Option$1,
    Placeholder: $899eda6015fcb069$var$Placeholder$1,
    SelectContainer: $899eda6015fcb069$var$SelectContainer,
    SingleValue: $899eda6015fcb069$var$SingleValue$1,
    ValueContainer: $899eda6015fcb069$var$ValueContainer
};
var $899eda6015fcb069$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $3lqla.default)((0, $3lqla.default)({}, $899eda6015fcb069$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("3lqla", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f7c3eae0ef2b2d$export$2e2bcd8739ae039; });

var $68AhI = parcelRequire("68AhI");
function $26f7c3eae0ef2b2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $26f7c3eae0ef2b2d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $26f7c3eae0ef2b2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $68AhI.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $26f7c3eae0ef2b2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("68AhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $477fa2cd6ae35a68$export$2e2bcd8739ae039; });

var $hS3oF = parcelRequire("hS3oF");
function $477fa2cd6ae35a68$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $hS3oF.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("hS3oF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d02a1d5eadf9e2a6$export$2e2bcd8739ae039; });

var $iVDBw = parcelRequire("iVDBw");

var $lWERO = parcelRequire("lWERO");
function $d02a1d5eadf9e2a6$export$2e2bcd8739ae039(arg) {
    var key = (0, $lWERO.default)(arg, "string");
    return (0, $iVDBw.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("lWERO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff9eb718a871c416$export$2e2bcd8739ae039; });

var $iVDBw = parcelRequire("iVDBw");
function $ff9eb718a871c416$export$2e2bcd8739ae039(input, hint) {
    if ((0, $iVDBw.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $iVDBw.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});




parcelRegister("i6eFW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2d42bc6ee88ad45$export$2e2bcd8739ae039; });

var $gRfNk = parcelRequire("gRfNk");

var $3UZzg = parcelRequire("3UZzg");

var $2g8dI = parcelRequire("2g8dI");

var $92hLG = parcelRequire("92hLG");
function $d2d42bc6ee88ad45$export$2e2bcd8739ae039(arr, i) {
    return (0, $gRfNk.default)(arr) || (0, $3UZzg.default)(arr, i) || (0, $2g8dI.default)(arr, i) || (0, $92hLG.default)();
}

});
parcelRegister("gRfNk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c45dd90f0d1dd682$export$2e2bcd8739ae039; });
function $c45dd90f0d1dd682$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3UZzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da65c20169066ee$export$2e2bcd8739ae039; });
function $2da65c20169066ee$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("2g8dI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a5373bd27310584$export$2e2bcd8739ae039; });

var $7LPtX = parcelRequire("7LPtX");
function $1a5373bd27310584$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7LPtX.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7LPtX.default)(o, minLen);
}

});
parcelRegister("7LPtX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a84db7ddefdc06e$export$2e2bcd8739ae039; });
function $5a84db7ddefdc06e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("92hLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6942155397604c6b$export$2e2bcd8739ae039; });
function $6942155397604c6b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4dmKN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311a06bfe69bb381$export$2e2bcd8739ae039; });

var $iNa2J = parcelRequire("iNa2J");
function $311a06bfe69bb381$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $iNa2J.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("iNa2J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae497ec4cb69b3a$export$2e2bcd8739ae039; });
function $dae497ec4cb69b3a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("euDes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d24cb355fc7a39$export$2e2bcd8739ae039; });
function $a8d24cb355fc7a39$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("iNJcg", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $daffdcc20edfbb65$export$deee3a793edee05f; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");
parcelRequire("04NGk");
var $cijjL = parcelRequire("cijjL");
var $04NGk = parcelRequire("04NGk");

var $cijjL = parcelRequire("cijjL");

var $fxYQE = parcelRequire("fxYQE");
function $daffdcc20edfbb65$var$getCssDimensions(element) {
    var css = (0, $fxYQE.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, $fxYQE.isHTMLElement)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, $cijjL.round)(width) !== offsetWidth || (0, $cijjL.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $daffdcc20edfbb65$var$unwrapElement(element) {
    return !(0, $fxYQE.isElement)(element) ? element.contextElement : element;
}
function $daffdcc20edfbb65$var$getScale(element) {
    var domElement = $daffdcc20edfbb65$var$unwrapElement(element);
    if (!(0, $fxYQE.isHTMLElement)(domElement)) return (0, $cijjL.createCoords)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = $daffdcc20edfbb65$var$getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, $cijjL.round)(rect.width) : rect.width) / width;
    var y = ($ ? (0, $cijjL.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $daffdcc20edfbb65$var$noOffsets = /*#__PURE__*/ (0, $cijjL.createCoords)(0);
function $daffdcc20edfbb65$var$getVisualOffsets(element) {
    var win = (0, $fxYQE.getWindow)(element);
    if (!(0, $fxYQE.isWebKit)() || !win.visualViewport) return $daffdcc20edfbb65$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $daffdcc20edfbb65$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $fxYQE.getWindow)(element)) return false;
    return isFixed;
}
function $daffdcc20edfbb65$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = $daffdcc20edfbb65$var$unwrapElement(element);
    var scale = (0, $cijjL.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $fxYQE.isElement)(offsetParent)) scale = $daffdcc20edfbb65$var$getScale(offsetParent);
        } else scale = $daffdcc20edfbb65$var$getScale(element);
    }
    var visualOffsets = $daffdcc20edfbb65$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $daffdcc20edfbb65$var$getVisualOffsets(domElement) : (0, $cijjL.createCoords)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = (0, $fxYQE.getWindow)(domElement);
        var offsetWin = offsetParent && (0, $fxYQE.isElement)(offsetParent) ? (0, $fxYQE.getWindow)(offsetParent) : offsetParent;
        var currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            var iframeScale = $daffdcc20edfbb65$var$getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, $fxYQE.getComputedStyle)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $fxYQE.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, $cijjL.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $daffdcc20edfbb65$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isOffsetParentAnElement = (0, $fxYQE.isHTMLElement)(offsetParent);
    var documentElement = (0, $fxYQE.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, $cijjL.createCoords)(1);
    var offsets = (0, $cijjL.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $fxYQE.getNodeName)(offsetParent) !== "body" || (0, $fxYQE.isOverflowElement)(documentElement)) scroll = (0, $fxYQE.getNodeScroll)(offsetParent);
        if ((0, $fxYQE.isHTMLElement)(offsetParent)) {
            var offsetRect = $daffdcc20edfbb65$var$getBoundingClientRect(offsetParent);
            scale = $daffdcc20edfbb65$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $daffdcc20edfbb65$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $daffdcc20edfbb65$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $daffdcc20edfbb65$var$getBoundingClientRect((0, $fxYQE.getDocumentElement)(element)).left + (0, $fxYQE.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $daffdcc20edfbb65$var$getDocumentRect(element) {
    var html = (0, $fxYQE.getDocumentElement)(element);
    var scroll = (0, $fxYQE.getNodeScroll)(element);
    var body = element.ownerDocument.body;
    var width = (0, $cijjL.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, $cijjL.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + $daffdcc20edfbb65$var$getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ((0, $fxYQE.getComputedStyle)(body).direction === "rtl") x += (0, $cijjL.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $daffdcc20edfbb65$var$getViewportRect(element, strategy) {
    var win = (0, $fxYQE.getWindow)(element);
    var html = (0, $fxYQE.getDocumentElement)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = (0, $fxYQE.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $daffdcc20edfbb65$var$getInnerBoundingClientRect(element, strategy) {
    var clientRect = $daffdcc20edfbb65$var$getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = (0, $fxYQE.isHTMLElement)(element) ? $daffdcc20edfbb65$var$getScale(element) : (0, $cijjL.createCoords)(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $daffdcc20edfbb65$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = $daffdcc20edfbb65$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $daffdcc20edfbb65$var$getDocumentRect((0, $fxYQE.getDocumentElement)(element));
    else if ((0, $fxYQE.isElement)(clippingAncestor)) rect = $daffdcc20edfbb65$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = $daffdcc20edfbb65$var$getVisualOffsets(element);
        rect = (0, $cxjpp._)((0, $do9pw._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $cijjL.rectToClientRect)(rect);
}
function $daffdcc20edfbb65$var$hasFixedPositionAncestor(element, stopNode) {
    var parentNode = (0, $fxYQE.getParentNode)(element);
    if (parentNode === stopNode || !(0, $fxYQE.isElement)(parentNode) || (0, $fxYQE.isLastTraversableNode)(parentNode)) return false;
    return (0, $fxYQE.getComputedStyle)(parentNode).position === "fixed" || $daffdcc20edfbb65$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $daffdcc20edfbb65$var$getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, $fxYQE.getOverflowAncestors)(element, [], false).filter(function(el) {
        return (0, $fxYQE.isElement)(el) && (0, $fxYQE.getNodeName)(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = (0, $fxYQE.getComputedStyle)(element).position === "fixed";
    var currentNode = elementIsFixed ? (0, $fxYQE.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $fxYQE.isElement)(currentNode) && !(0, $fxYQE.isLastTraversableNode)(currentNode)){
        var computedStyle = (0, $fxYQE.getComputedStyle)(currentNode);
        var currentNodeIsContaining = (0, $fxYQE.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $fxYQE.isOverflowElement)(currentNode) && !currentNodeIsContaining && $daffdcc20edfbb65$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $fxYQE.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $daffdcc20edfbb65$var$getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === "clippingAncestors" ? $daffdcc20edfbb65$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, $c6Xmf._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstClippingAncestor = clippingAncestors[0];
    var clippingRect = clippingAncestors.reduce(function(accRect, clippingAncestor) {
        var rect = $daffdcc20edfbb65$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cijjL.max)(rect.top, accRect.top);
        accRect.right = (0, $cijjL.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cijjL.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cijjL.max)(rect.left, accRect.left);
        return accRect;
    }, $daffdcc20edfbb65$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $daffdcc20edfbb65$var$getDimensions(element) {
    return $daffdcc20edfbb65$var$getCssDimensions(element);
}
function $daffdcc20edfbb65$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, $fxYQE.isHTMLElement)(offsetParent);
    var documentElement = (0, $fxYQE.getDocumentElement)(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = $daffdcc20edfbb65$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, $cijjL.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fxYQE.getNodeName)(offsetParent) !== "body" || (0, $fxYQE.isOverflowElement)(documentElement)) scroll = (0, $fxYQE.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = $daffdcc20edfbb65$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $daffdcc20edfbb65$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $daffdcc20edfbb65$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $fxYQE.isHTMLElement)(element) || (0, $fxYQE.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $daffdcc20edfbb65$var$getOffsetParent(element, polyfill) {
    var window = (0, $fxYQE.getWindow)(element);
    if (!(0, $fxYQE.isHTMLElement)(element)) return window;
    var offsetParent = $daffdcc20edfbb65$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $fxYQE.isTableElement)(offsetParent) && (0, $fxYQE.getComputedStyle)(offsetParent).position === "static")offsetParent = $daffdcc20edfbb65$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $fxYQE.getNodeName)(offsetParent) === "html" || (0, $fxYQE.getNodeName)(offsetParent) === "body" && (0, $fxYQE.getComputedStyle)(offsetParent).position === "static" && !(0, $fxYQE.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $fxYQE.getContainingBlock)(element) || window;
}
var $daffdcc20edfbb65$var$getElementRects = function() {
    var _ref = (0, $kSuI9._)(function(_ref) {
        var reference, floating, strategy, getOffsetParentFn, getDimensionsFn, _tmp, _tmp1, _tmp2;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    reference = _ref.reference, floating = _ref.floating, strategy = _ref.strategy;
                    getOffsetParentFn = this.getOffsetParent || $daffdcc20edfbb65$var$getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    _tmp = {};
                    _tmp1 = [
                        reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(floating)
                    ];
                case 1:
                    _tmp.reference = $daffdcc20edfbb65$var$getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                        _state.sent(),
                        strategy
                    ]));
                    _tmp2 = [
                        {
                            x: 0,
                            y: 0
                        }
                    ];
                    return [
                        4,
                        getDimensionsFn(floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.floating = (0, $do9pw._).apply(void 0, _tmp2.concat([
                            _state.sent()
                        ])), _tmp)
                    ];
            }
        });
    });
    return function getElementRects(_ref1) {
        return _ref.apply(this, arguments);
    };
}();
function $daffdcc20edfbb65$var$isRTL(element) {
    return (0, $fxYQE.getComputedStyle)(element).direction === "rtl";
}
var $daffdcc20edfbb65$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $daffdcc20edfbb65$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, $fxYQE.getDocumentElement),
    getClippingRect: $daffdcc20edfbb65$var$getClippingRect,
    getOffsetParent: $daffdcc20edfbb65$var$getOffsetParent,
    getElementRects: $daffdcc20edfbb65$var$getElementRects,
    getClientRects: $daffdcc20edfbb65$var$getClientRects,
    getDimensions: $daffdcc20edfbb65$var$getDimensions,
    getScale: $daffdcc20edfbb65$var$getScale,
    isElement: (0, $fxYQE.isElement),
    isRTL: $daffdcc20edfbb65$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $daffdcc20edfbb65$var$observeMove(element, onMove) {
    var io = null;
    var timeoutId;
    var root = (0, $fxYQE.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top, width = _element_getBoundingClientRect.width, height = _element_getBoundingClientRect.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, $cijjL.floor)(top);
        var insetRight = (0, $cijjL.floor)(root.clientWidth - (left + width));
        var insetBottom = (0, $cijjL.floor)(root.clientHeight - (top + height));
        var insetLeft = (0, $cijjL.floor)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, $cijjL.max)(0, (0, $cijjL.min)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $cxjpp._)((0, $do9pw._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $daffdcc20edfbb65$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === "function" : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = $daffdcc20edfbb65$var$unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, $c6Xmf._)(referenceEl ? (0, $fxYQE.getOverflowAncestors)(referenceEl) : []).concat((0, $c6Xmf._)((0, $fxYQE.getOverflowAncestors)(floating))) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? $daffdcc20edfbb65$var$observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, $cv9Rk._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? $daffdcc20edfbb65$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = $daffdcc20edfbb65$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ var $daffdcc20edfbb65$export$48a53dcb22e581d0 = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, $do9pw._)({
        platform: $daffdcc20edfbb65$export$722a64dea1b767dc
    }, options);
    var platformWithCache = (0, $cxjpp._)((0, $do9pw._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $04NGk.computePosition)(reference, floating, (0, $cxjpp._)((0, $do9pw._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("04NGk", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $00e6e9961094a0e0$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("cijjL")).rectToClientRect; });

var $kSuI9 = parcelRequire("kSuI9");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $cijjL = parcelRequire("cijjL");
function $00e6e9961094a0e0$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, $cijjL.getSideAxis)(placement);
    var alignmentAxis = (0, $cijjL.getAlignmentAxis)(placement);
    var alignLength = (0, $cijjL.getAxisLength)(alignmentAxis);
    var side = (0, $cijjL.getSide)(placement);
    var isVertical = sideAxis === "y";
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cijjL.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var $00e6e9961094a0e0$export$48a53dcb22e581d0 = function() {
    var _ref = (0, $kSuI9._)(function(reference, floating, config) {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    validMiddleware = middleware.filter(Boolean);
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = $00e6e9961094a0e0$var$computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    middlewareData = {};
                    resetCount = 0;
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < validMiddleware.length)) return [
                        3,
                        11
                    ];
                    _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platform,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData = (0, $cxjpp._)((0, $do9pw._)({}, middlewareData), (0, $3sHb8._)({}, name, (0, $do9pw._)({}, middlewareData[name], data)));
                    if (!(reset && resetCount <= 50)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = $00e6e9961094a0e0$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    return [
                        3,
                        10
                    ];
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
function $00e6e9961094a0e0$export$37b6bde19b108ecc(state, options) {
    return $00e6e9961094a0e0$var$_detectOverflow.apply(this, arguments);
}
function $00e6e9961094a0e0$var$_detectOverflow() {
    $00e6e9961094a0e0$var$_detectOverflow = /**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ (0, $kSuI9._)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? "clippingAncestors" : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? "viewport" : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? "floating" : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, $cijjL.getPaddingObject)(padding);
                    altContext = elementContext === "floating" ? "reference" : "floating";
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, $cijjL.rectToClientRect).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? (0, $cxjpp._)((0, $do9pw._)({}, rects.floating), {
                        x: x,
                        y: y
                    }) : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = (0, $cijjL.rectToClientRect).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return $00e6e9961094a0e0$var$_detectOverflow.apply(this, arguments);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $00e6e9961094a0e0$export$f2120bbfa5450bd2 = function(options) {
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, $cijjL.evaluate)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, $cijjL.getPaddingObject)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, $cijjL.getAlignmentAxis)(placement);
                            length = (0, $cijjL.getAxisLength)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, $cijjL.min)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, $cijjL.min)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, $cijjL.clamp)(min$1, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, $cijjL.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, $3sHb8._)(_obj1, axis, coords[axis] + alignmentOffset), (0, $3sHb8._)(_obj1, "data", (0, $do9pw._)((_obj = {}, (0, $3sHb8._)(_obj, axis, offset), (0, $3sHb8._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, $3sHb8._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function $00e6e9961094a0e0$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, $c6Xmf._)(allowedPlacements.filter(function(placement) {
        return (0, $cijjL.getAlignment)(placement) === alignment;
    })).concat((0, $c6Xmf._)(allowedPlacements.filter(function(placement) {
        return (0, $cijjL.getAlignment)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, $cijjL.getSide)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, $cijjL.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cijjL.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $00e6e9961094a0e0$export$91fb6ecbd551914 = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, overflow, currentIndex, currentPlacement, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, $cijjL.placements) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, $dRLPW._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, $cijjL.placements) ? $00e6e9961094a0e0$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, $cijjL.getAlignmentSides).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[(0, $cijjL.getSide)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, $c6Xmf._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, $cijjL.getAlignment)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, $cijjL.getAlignment)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $00e6e9961094a0e0$export$8a83211c878a3f1f = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, isBasePlacement, rtl, fallbackPlacements, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$map$so, placement1;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $cijjL.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? "bestFit" : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? "none" : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, $dRLPW._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, $cijjL.getSide)(placement);
                            isBasePlacement = (0, $cijjL.getSide)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, $cijjL.getOppositePlacement)(initialPlacement)
                            ] : (0, $cijjL.getExpandedPlacements)(initialPlacement));
                            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, $c6Xmf._)((0, $cijjL.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, $c6Xmf._)(fallbackPlacements));
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, $cijjL.getAlignmentSides)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, $c6Xmf._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) // Try next placement and re-run the lifecycle.
                                return [
                                    2,
                                    {
                                        data: {
                                            index: nextIndex,
                                            overflows: overflowsData
                                        },
                                        reset: {
                                            placement: nextPlacement
                                        }
                                    }
                                ];
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$map$so = overflowsData.map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$map$so[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $00e6e9961094a0e0$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $00e6e9961094a0e0$var$isAnySideFullyClipped(overflow) {
    return (0, $cijjL.sides).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $00e6e9961094a0e0$export$fe8985bb6374093c = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var rects, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects;
                            _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? "referenceHidden" : _evaluate_strategy, detectOverflowOptions = (0, $dRLPW._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, (0, $cxjpp._)((0, $do9pw._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = $00e6e9961094a0e0$var$getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: $00e6e9961094a0e0$var$isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, (0, $cxjpp._)((0, $do9pw._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = $00e6e9961094a0e0$var$getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: $00e6e9961094a0e0$var$isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function $00e6e9961094a0e0$var$getBoundingRect(rects) {
    var minX = (0, $cijjL.min).apply(void 0, (0, $c6Xmf._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, $cijjL.min).apply(void 0, (0, $c6Xmf._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, $cijjL.max).apply(void 0, (0, $c6Xmf._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, $cijjL.max).apply(void 0, (0, $c6Xmf._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $00e6e9961094a0e0$var$getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, $cijjL.rectToClientRect)($00e6e9961094a0e0$var$getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $00e6e9961094a0e0$export$18c8ad048e32c7d5 = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, $cijjL.getSideAxis)(placement) === "y") {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, $cijjL.getSide)(placement) === "top";
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = (0, $cijjL.getSide)(placement) === "left";
                        var maxRight = (0, $cijjL.max).apply(void 0, (0, $c6Xmf._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, $cijjL.min).apply(void 0, (0, $c6Xmf._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = $00e6e9961094a0e0$var$getRectsByLine(nativeClientRects);
                            fallback = (0, $cijjL.rectToClientRect)($00e6e9961094a0e0$var$getBoundingRect(nativeClientRects));
                            paddingObject = (0, $cijjL.getPaddingObject)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $00e6e9961094a0e0$var$convertValueToCoords(state, options) {
    return $00e6e9961094a0e0$var$_convertValueToCoords.apply(this, arguments);
}
function $00e6e9961094a0e0$var$_convertValueToCoords() {
    $00e6e9961094a0e0$var$_convertValueToCoords = // For type backwards-compatibility, the `OffsetOptions` type was also
    // Derivable.
    (0, $kSuI9._)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, $cijjL.getSide)(placement);
                    alignment = (0, $cijjL.getAlignment)(placement);
                    isVertical = (0, $cijjL.getSideAxis)(placement) === "y";
                    mainAxisMulti = [
                        "left",
                        "top"
                    ].includes(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, $cijjL.evaluate)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : (0, $do9pw._)({
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null
                    }, rawValue), mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return $00e6e9961094a0e0$var$_convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $00e6e9961094a0e0$export$cc800923e997bb8 = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var x, y, diffCoords;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y;
                            return [
                                4,
                                $00e6e9961094a0e0$var$convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: diffCoords
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $00e6e9961094a0e0$export$fba63a578e423eb = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var x, y, placement, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement;
                            _evaluate = (0, $cijjL.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, $dRLPW._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, $cijjL.getSideAxis)((0, $cijjL.getSide)(placement));
                            mainAxis = (0, $cijjL.getOppositeAxis)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = (0, $cijjL.clamp)(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = (0, $cijjL.clamp)(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, $cxjpp._)((0, $do9pw._)({}, state), (_obj = {}, (0, $3sHb8._)(_obj, mainAxis, mainAxisCoord), (0, $3sHb8._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, $cxjpp._)((0, $do9pw._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $00e6e9961094a0e0$export$7bf07e38f3dc4b69 = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, $cijjL.getSideAxis)(placement);
            var mainAxis = (0, $cijjL.getOppositeAxis)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, $cijjL.evaluate)(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $do9pw._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $cijjL.getSide)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return(_obj = {}, (0, $3sHb8._)(_obj, mainAxis, mainAxisCoord), (0, $3sHb8._)(_obj, crossAxis, crossAxisCoord), _obj);
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $00e6e9961094a0e0$export$346677f925de839c = function size(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn: function(state) {
            return (0, $kSuI9._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, maximumClippingWidth, maximumClippingHeight, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $cijjL.evaluate)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, $dRLPW._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                $00e6e9961094a0e0$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, $cijjL.getSide)(placement);
                            alignment = (0, $cijjL.getAlignment)(placement);
                            isYAxis = (0, $cijjL.getSideAxis)(placement) === "y";
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            overflowAvailableHeight = height - overflow[heightSide];
                            overflowAvailableWidth = width - overflow[widthSide];
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (isYAxis) {
                                maximumClippingWidth = width - overflow.left - overflow.right;
                                availableWidth = alignment || noShift ? (0, $cijjL.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                            } else {
                                maximumClippingHeight = height - overflow.top - overflow.bottom;
                                availableHeight = alignment || noShift ? (0, $cijjL.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                            }
                            if (noShift && !alignment) {
                                xMin = (0, $cijjL.max)(overflow.left, 0);
                                xMax = (0, $cijjL.max)(overflow.right, 0);
                                yMin = (0, $cijjL.max)(overflow.top, 0);
                                yMax = (0, $cijjL.max)(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cijjL.max)(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cijjL.max)(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, $cxjpp._)((0, $do9pw._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};

});
parcelRegister("cijjL", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $8f362695770b2996$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $8f362695770b2996$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $8f362695770b2996$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $8f362695770b2996$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $8f362695770b2996$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $8f362695770b2996$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $8f362695770b2996$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $8f362695770b2996$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $8f362695770b2996$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $8f362695770b2996$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $8f362695770b2996$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $8f362695770b2996$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $8f362695770b2996$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $8f362695770b2996$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $8f362695770b2996$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $8f362695770b2996$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $8f362695770b2996$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $8f362695770b2996$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $8f362695770b2996$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $8f362695770b2996$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $8f362695770b2996$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $8f362695770b2996$export$ee05aea0aeecbad4; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
var $8f362695770b2996$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
var $8f362695770b2996$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
var $8f362695770b2996$export$803cd8101b6c182b = /*#__PURE__*/ $8f362695770b2996$export$832b6fa47fa053d2.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + $8f362695770b2996$export$27b07d8a310ed8b5[0], side + "-" + $8f362695770b2996$export$27b07d8a310ed8b5[1]);
}, []);
var $8f362695770b2996$export$96ec731ed4dcb222 = Math.min;
var $8f362695770b2996$export$8960430cfd85939f = Math.max;
var $8f362695770b2996$export$2077e0241d6afd3c = Math.round;
var $8f362695770b2996$export$a3fe094919f356fd = Math.floor;
var $8f362695770b2996$export$a397704b5e280835 = function(v) {
    return {
        x: v,
        y: v
    };
};
var $8f362695770b2996$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var $8f362695770b2996$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $8f362695770b2996$export$7d15b64cf5a3a4c4(start, value, end) {
    return $8f362695770b2996$export$8960430cfd85939f(start, $8f362695770b2996$export$96ec731ed4dcb222(value, end));
}
function $8f362695770b2996$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $8f362695770b2996$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $8f362695770b2996$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $8f362695770b2996$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $8f362695770b2996$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $8f362695770b2996$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($8f362695770b2996$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $8f362695770b2996$export$2b57e0052a6d6d4c(placement) {
    return $8f362695770b2996$export$8a000a963141ac32($8f362695770b2996$export$f28e8f882010718a(placement));
}
function $8f362695770b2996$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = $8f362695770b2996$export$f0989780f32bfcda(placement);
    var alignmentAxis = $8f362695770b2996$export$2b57e0052a6d6d4c(placement);
    var length = $8f362695770b2996$export$320bd9d53520c68a(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $8f362695770b2996$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $8f362695770b2996$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $8f362695770b2996$export$496432a3699e50b1(placement) {
    var oppositePlacement = $8f362695770b2996$export$9c5e28bad23365fa(placement);
    return [
        $8f362695770b2996$export$2b182c584985588b(placement),
        oppositePlacement,
        $8f362695770b2996$export$2b182c584985588b(oppositePlacement)
    ];
}
function $8f362695770b2996$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, function(alignment) {
        return $8f362695770b2996$var$oppositeAlignmentMap[alignment];
    });
}
function $8f362695770b2996$var$getSideList(side, isStart, rtl) {
    var lr = [
        "left",
        "right"
    ];
    var rl = [
        "right",
        "left"
    ];
    var tb = [
        "top",
        "bottom"
    ];
    var bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $8f362695770b2996$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    var alignment = $8f362695770b2996$export$f0989780f32bfcda(placement);
    var list = $8f362695770b2996$var$getSideList($8f362695770b2996$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map($8f362695770b2996$export$2b182c584985588b));
    }
    return list;
}
function $8f362695770b2996$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, function(side) {
        return $8f362695770b2996$var$oppositeSideMap[side];
    });
}
function $8f362695770b2996$export$1c66dbf1a9e34223(padding) {
    return (0, $do9pw._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $8f362695770b2996$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $8f362695770b2996$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $8f362695770b2996$export$ee05aea0aeecbad4(rect) {
    return (0, $cxjpp._)((0, $do9pw._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fxYQE", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $b519234822e5f0b6$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $b519234822e5f0b6$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $b519234822e5f0b6$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $b519234822e5f0b6$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $b519234822e5f0b6$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $b519234822e5f0b6$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $b519234822e5f0b6$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $b519234822e5f0b6$export$71535ffaa902797f; });
$parcel$export(module.exports, "isContainingBlock", function () { return $b519234822e5f0b6$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $b519234822e5f0b6$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $b519234822e5f0b6$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $b519234822e5f0b6$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $b519234822e5f0b6$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $b519234822e5f0b6$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $b519234822e5f0b6$export$3b57c1601291186b; });
function $b519234822e5f0b6$export$651544f548703224(node) {
    if ($b519234822e5f0b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $b519234822e5f0b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b519234822e5f0b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b519234822e5f0b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b519234822e5f0b6$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $b519234822e5f0b6$export$38b2d434cce3ea22(value).Node;
}
function $b519234822e5f0b6$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $b519234822e5f0b6$export$38b2d434cce3ea22(value).Element;
}
function $b519234822e5f0b6$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $b519234822e5f0b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b519234822e5f0b6$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $b519234822e5f0b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b519234822e5f0b6$export$989e911fa9af580a(element) {
    var _getComputedStyle = $b519234822e5f0b6$export$3735103072e4a80(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $b519234822e5f0b6$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($b519234822e5f0b6$export$651544f548703224(element));
}
function $b519234822e5f0b6$export$d6c4e8150c35fed1(element) {
    var webkit = $b519234822e5f0b6$export$78551043582a6a98();
    var css = $b519234822e5f0b6$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some(function(value) {
        return (css.willChange || "").includes(value);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(value) {
        return (css.contain || "").includes(value);
    });
}
function $b519234822e5f0b6$export$940d8225183e1404(element) {
    var currentNode = $b519234822e5f0b6$export$4e12058fc4d51d56(element);
    while($b519234822e5f0b6$export$1b3bfaa9684536aa(currentNode) && !$b519234822e5f0b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b519234822e5f0b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $b519234822e5f0b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b519234822e5f0b6$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $b519234822e5f0b6$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($b519234822e5f0b6$export$651544f548703224(node));
}
function $b519234822e5f0b6$export$3735103072e4a80(element) {
    return $b519234822e5f0b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b519234822e5f0b6$export$dc8fc79fa2800137(element) {
    if ($b519234822e5f0b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $b519234822e5f0b6$export$4e12058fc4d51d56(node) {
    if ($b519234822e5f0b6$export$651544f548703224(node) === "html") return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b519234822e5f0b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b519234822e5f0b6$export$e495491855dc5418(node);
    return $b519234822e5f0b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b519234822e5f0b6$export$7cd01a57c8ca906c(node) {
    var parentNode = $b519234822e5f0b6$export$4e12058fc4d51d56(node);
    if ($b519234822e5f0b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b519234822e5f0b6$export$1b3bfaa9684536aa(parentNode) && $b519234822e5f0b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b519234822e5f0b6$export$7cd01a57c8ca906c(parentNode);
}
function $b519234822e5f0b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = $b519234822e5f0b6$export$7cd01a57c8ca906c(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = $b519234822e5f0b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $b519234822e5f0b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $b519234822e5f0b6$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $b519234822e5f0b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("i2lfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d218e6e45cd4e345$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $d218e6e45cd4e345$var$index = (0, $1Mpn7.useLayoutEffect);
var $d218e6e45cd4e345$export$2e2bcd8739ae039 = $d218e6e45cd4e345$var$index;

});


parcelRegister("bIfY9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $887030eefee80161$export$2e2bcd8739ae039; });

var $JHXmB = parcelRequire("JHXmB");

var $iunch = parcelRequire("iunch");

var $1Mpn7 = parcelRequire("1Mpn7");

var $h0r3Z = parcelRequire("h0r3Z");

var $7qdHr = parcelRequire("7qdHr");

var $9t3nQ = parcelRequire("9t3nQ");

var $bOy9g = parcelRequire("bOy9g");
parcelRequire("OCMJz");
parcelRequire("e6gyJ");
parcelRequire("04Kcc");
parcelRequire("6QU8A");
parcelRequire("2Yk1N");
parcelRequire("eZhUW");
parcelRequire("25Lr6");
parcelRequire("eetQ9");

parcelRequire("2nffd");
parcelRequire("1UIph");
parcelRequire("jjExS");
parcelRequire("eaouD");

parcelRequire("i2lfV");
var $887030eefee80161$var$StateManagedSelect = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $JHXmB.u)(props);
    return /*#__PURE__*/ $1Mpn7.createElement((0, $h0r3Z.S), (0, $iunch.default)({
        ref: ref
    }, baseSelectProps));
});
var $887030eefee80161$export$2e2bcd8739ae039 = $887030eefee80161$var$StateManagedSelect;
var $887030eefee80161$export$a7deb1594c5ce10e = function NonceProvider(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $1Mpn7.useMemo)(function() {
        return (0, $9t3nQ.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $1Mpn7.createElement((0, $7qdHr.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("JHXmB", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $08964cecb0d971c2$export$3b14a55fb2447963; });

var $3lqla = parcelRequire("3lqla");

var $i6eFW = parcelRequire("i6eFW");

var $4dmKN = parcelRequire("4dmKN");

var $1Mpn7 = parcelRequire("1Mpn7");
var $08964cecb0d971c2$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $08964cecb0d971c2$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $4dmKN.default)(_ref, $08964cecb0d971c2$var$_excluded);
    var _useState = (0, $1Mpn7.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $i6eFW.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $1Mpn7.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $i6eFW.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $1Mpn7.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $i6eFW.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $1Mpn7.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $1Mpn7.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $1Mpn7.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $1Mpn7.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $3lqla.default)((0, $3lqla.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("h0r3Z", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $c6176df7343acb0a$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "g", function () { return $c6176df7343acb0a$export$39b482c5e57630a8; });
$parcel$export(module.exports, "m", function () { return $c6176df7343acb0a$export$953cecd6e717a553; });
$parcel$export(module.exports, "S", function () { return $c6176df7343acb0a$export$25ce5a424b770e84; });

var $iunch = parcelRequire("iunch");

var $3lqla = parcelRequire("3lqla");

var $hM7Tj = parcelRequire("hM7Tj");

var $3fnhl = parcelRequire("3fnhl");

var $e52ho = parcelRequire("e52ho");

var $8faVr = parcelRequire("8faVr");

var $kTtK1 = parcelRequire("kTtK1");

var $1Mpn7 = parcelRequire("1Mpn7");

var $bOy9g = parcelRequire("bOy9g");

var $fBy54 = parcelRequire("fBy54");

var $eUBSC = parcelRequire("eUBSC");

var $4dmKN = parcelRequire("4dmKN");
function $c6176df7343acb0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $c6176df7343acb0a$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $c6176df7343acb0a$var$A11yText = function A11yText(props) {
    return (0, $fBy54.jsx)("span", (0, $iunch.default)({
        css: $c6176df7343acb0a$var$_ref
    }, props));
};
var $c6176df7343acb0a$var$A11yText$1 = $c6176df7343acb0a$var$A11yText;
var $c6176df7343acb0a$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $c6176df7343acb0a$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $1Mpn7.useMemo)(function() {
        return (0, $3lqla.default)((0, $3lqla.default)({}, $c6176df7343acb0a$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $1Mpn7.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $3lqla.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $1Mpn7.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $1Mpn7.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $1Mpn7.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, (0, $fBy54.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $fBy54.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, (0, $fBy54.jsx)($c6176df7343acb0a$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $fBy54.jsx)($c6176df7343acb0a$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $c6176df7343acb0a$var$LiveRegion$1 = $c6176df7343acb0a$var$LiveRegion;
var $c6176df7343acb0a$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $c6176df7343acb0a$var$anyDiacritic = new RegExp("[" + $c6176df7343acb0a$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $c6176df7343acb0a$var$diacriticToBase = {};
for(var $c6176df7343acb0a$var$i = 0; $c6176df7343acb0a$var$i < $c6176df7343acb0a$var$diacritics.length; $c6176df7343acb0a$var$i++){
    var $c6176df7343acb0a$var$diacritic = $c6176df7343acb0a$var$diacritics[$c6176df7343acb0a$var$i];
    for(var $c6176df7343acb0a$var$j = 0; $c6176df7343acb0a$var$j < $c6176df7343acb0a$var$diacritic.letters.length; $c6176df7343acb0a$var$j++)$c6176df7343acb0a$var$diacriticToBase[$c6176df7343acb0a$var$diacritic.letters[$c6176df7343acb0a$var$j]] = $c6176df7343acb0a$var$diacritic.base;
}
var $c6176df7343acb0a$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($c6176df7343acb0a$var$anyDiacritic, function(match) {
        return $c6176df7343acb0a$var$diacriticToBase[match];
    });
};
var $c6176df7343acb0a$var$memoizedStripDiacriticsForInput = (0, $eUBSC.default)($c6176df7343acb0a$var$stripDiacritics);
var $c6176df7343acb0a$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $c6176df7343acb0a$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $c6176df7343acb0a$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $3lqla.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c6176df7343acb0a$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $c6176df7343acb0a$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $c6176df7343acb0a$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c6176df7343acb0a$var$memoizedStripDiacriticsForInput(input);
            candidate = $c6176df7343acb0a$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $c6176df7343acb0a$var$_excluded = [
    "innerRef"
];
function $c6176df7343acb0a$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $4dmKN.default)(_ref, $c6176df7343acb0a$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $bOy9g.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $fBy54.jsx)("input", (0, $iunch.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $fBy54.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $c6176df7343acb0a$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $c6176df7343acb0a$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $1Mpn7.useRef)(false);
    var isTop = (0, $1Mpn7.useRef)(false);
    var touchStart = (0, $1Mpn7.useRef)(0);
    var scrollTarget = (0, $1Mpn7.useRef)(null);
    var handleEventDelta = (0, $1Mpn7.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $c6176df7343acb0a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $1Mpn7.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $1Mpn7.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $1Mpn7.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $1Mpn7.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $bOy9g.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $1Mpn7.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $c6176df7343acb0a$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $c6176df7343acb0a$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $c6176df7343acb0a$var$preventTouchMove(e) {
    e.preventDefault();
}
function $c6176df7343acb0a$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c6176df7343acb0a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c6176df7343acb0a$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $c6176df7343acb0a$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $c6176df7343acb0a$var$activeScrollLocks = 0;
var $c6176df7343acb0a$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c6176df7343acb0a$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $1Mpn7.useRef)({});
    var scrollTarget = (0, $1Mpn7.useRef)(null);
    var addScrollLock = (0, $1Mpn7.useCallback)(function(touchScrollTarget) {
        if (!$c6176df7343acb0a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c6176df7343acb0a$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c6176df7343acb0a$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c6176df7343acb0a$var$LOCK_STYLES).forEach(function(key) {
                var val = $c6176df7343acb0a$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c6176df7343acb0a$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $c6176df7343acb0a$var$preventTouchMove, $c6176df7343acb0a$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $c6176df7343acb0a$var$preventInertiaScroll, $c6176df7343acb0a$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $c6176df7343acb0a$var$allowTouchMove, $c6176df7343acb0a$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c6176df7343acb0a$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $1Mpn7.useCallback)(function(touchScrollTarget) {
        if (!$c6176df7343acb0a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c6176df7343acb0a$var$activeScrollLocks = Math.max($c6176df7343acb0a$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c6176df7343acb0a$var$activeScrollLocks < 1) $c6176df7343acb0a$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c6176df7343acb0a$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $c6176df7343acb0a$var$preventTouchMove, $c6176df7343acb0a$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $c6176df7343acb0a$var$preventInertiaScroll, $c6176df7343acb0a$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $c6176df7343acb0a$var$allowTouchMove, $c6176df7343acb0a$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $c6176df7343acb0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c6176df7343acb0a$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $c6176df7343acb0a$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $c6176df7343acb0a$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $c6176df7343acb0a$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $c6176df7343acb0a$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, lockEnabled && (0, $fBy54.jsx)("div", {
        onClick: $c6176df7343acb0a$var$blurSelectInput,
        css: $c6176df7343acb0a$var$_ref2$1
    }), children(targetRef));
}
function $c6176df7343acb0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c6176df7343acb0a$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $c6176df7343acb0a$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $fBy54.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c6176df7343acb0a$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $c6176df7343acb0a$var$RequiredInput$1 = $c6176df7343acb0a$var$RequiredInput;
var $c6176df7343acb0a$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $c6176df7343acb0a$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $c6176df7343acb0a$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $c6176df7343acb0a$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $c6176df7343acb0a$var$defaultStyles = {
    clearIndicator: (0, $bOy9g.a),
    container: (0, $bOy9g.b),
    control: (0, $bOy9g.d),
    dropdownIndicator: (0, $bOy9g.e),
    group: (0, $bOy9g.g),
    groupHeading: (0, $bOy9g.f),
    indicatorsContainer: (0, $bOy9g.i),
    indicatorSeparator: (0, $bOy9g.h),
    input: (0, $bOy9g.j),
    loadingIndicator: (0, $bOy9g.l),
    loadingMessage: (0, $bOy9g.k),
    menu: (0, $bOy9g.m),
    menuList: (0, $bOy9g.n),
    menuPortal: (0, $bOy9g.o),
    multiValue: (0, $bOy9g.p),
    multiValueLabel: (0, $bOy9g.q),
    multiValueRemove: (0, $bOy9g.t),
    noOptionsMessage: (0, $bOy9g.u),
    option: (0, $bOy9g.v),
    placeholder: (0, $bOy9g.w),
    singleValue: (0, $bOy9g.x),
    valueContainer: (0, $bOy9g.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $c6176df7343acb0a$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $3lqla.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $c6176df7343acb0a$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $c6176df7343acb0a$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $c6176df7343acb0a$var$baseUnit = 4;
// The minimum height of the control
var $c6176df7343acb0a$var$controlHeight = 38;
// The amount of space between the control and menu */
var $c6176df7343acb0a$var$menuGutter = $c6176df7343acb0a$var$baseUnit * 2;
var $c6176df7343acb0a$var$spacing = {
    baseUnit: $c6176df7343acb0a$var$baseUnit,
    controlHeight: $c6176df7343acb0a$var$controlHeight,
    menuGutter: $c6176df7343acb0a$var$menuGutter
};
var $c6176df7343acb0a$export$4368d992c4eafac0 = {
    borderRadius: $c6176df7343acb0a$var$borderRadius,
    colors: $c6176df7343acb0a$var$colors,
    spacing: $c6176df7343acb0a$var$spacing
};
var $c6176df7343acb0a$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $bOy9g.z)(),
    captureMenuScroll: !(0, $bOy9g.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $c6176df7343acb0a$export$db3b6bfb95261072(),
    formatGroupLabel: $c6176df7343acb0a$var$formatGroupLabel,
    getOptionLabel: $c6176df7343acb0a$export$8b22cf2602fb60ce,
    getOptionValue: $c6176df7343acb0a$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $c6176df7343acb0a$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $bOy9g.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $c6176df7343acb0a$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $c6176df7343acb0a$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $c6176df7343acb0a$var$_isOptionSelected(props, option, selectValue);
    var label = $c6176df7343acb0a$var$getOptionLabel(props, option);
    var value = $c6176df7343acb0a$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $c6176df7343acb0a$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $c6176df7343acb0a$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $c6176df7343acb0a$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $c6176df7343acb0a$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $c6176df7343acb0a$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $bOy9g.K));
}
function $c6176df7343acb0a$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $kTtK1.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $c6176df7343acb0a$var$buildFocusableOptions(props, selectValue) {
    return $c6176df7343acb0a$var$buildFocusableOptionsFromCategorizedOptions($c6176df7343acb0a$var$buildCategorizedOptions(props, selectValue));
}
function $c6176df7343acb0a$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$c6176df7343acb0a$var$shouldHideSelectedOptions(props) || !isSelected) && $c6176df7343acb0a$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $c6176df7343acb0a$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $c6176df7343acb0a$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $c6176df7343acb0a$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $c6176df7343acb0a$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $c6176df7343acb0a$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $c6176df7343acb0a$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $c6176df7343acb0a$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $c6176df7343acb0a$var$getOptionValue(props, i) === candidate;
    });
}
function $c6176df7343acb0a$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $c6176df7343acb0a$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $c6176df7343acb0a$var$instanceId = 1;
var $c6176df7343acb0a$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $e52ho.default)(Select, _Component);
    var _super = (0, $8faVr.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $hM7Tj.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $bOy9g.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $bOy9g.B)([].concat((0, $kTtK1.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $bOy9g.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $bOy9g.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $bOy9g.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $bOy9g.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $bOy9g.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $bOy9g.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $c6176df7343acb0a$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $c6176df7343acb0a$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $c6176df7343acb0a$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $bOy9g.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $c6176df7343acb0a$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $c6176df7343acb0a$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $3lqla.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $bOy9g.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $c6176df7343acb0a$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$c6176df7343acb0a$var$instanceId);
        _this.state.selectValue = (0, $bOy9g.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $3fnhl.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $bOy9g.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $bOy9g.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $c6176df7343acb0a$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($c6176df7343acb0a$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $3lqla.default)((0, $3lqla.default)({}, $c6176df7343acb0a$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $c6176df7343acb0a$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $c6176df7343acb0a$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $c6176df7343acb0a$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $3lqla.default)((0, $3lqla.default)((0, $3lqla.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $1Mpn7.createElement($c6176df7343acb0a$var$DummyInput, (0, $iunch.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $bOy9g.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $1Mpn7.createElement(Input, (0, $iunch.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $1Mpn7.createElement(Placeholder, (0, $iunch.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $1Mpn7.createElement(MultiValue, (0, $iunch.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $1Mpn7.createElement(SingleValue, (0, $iunch.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $1Mpn7.createElement(ClearIndicator, (0, $iunch.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $1Mpn7.createElement(LoadingIndicator, (0, $iunch.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $1Mpn7.createElement(IndicatorSeparator, (0, $iunch.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $1Mpn7.createElement(DropdownIndicator, (0, $iunch.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function onHover() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function onSelect() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $1Mpn7.createElement(Option, (0, $iunch.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $1Mpn7.createElement(Group, (0, $iunch.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $1Mpn7.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $1Mpn7.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $1Mpn7.createElement((0, $bOy9g.M), (0, $iunch.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $1Mpn7.createElement(Menu, (0, $iunch.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $1Mpn7.createElement($c6176df7343acb0a$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $1Mpn7.createElement(MenuList, (0, $iunch.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $1Mpn7.createElement(MenuPortal, (0, $iunch.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $1Mpn7.createElement($c6176df7343acb0a$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $1Mpn7.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $1Mpn7.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $1Mpn7.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $1Mpn7.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $1Mpn7.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $1Mpn7.createElement($c6176df7343acb0a$var$LiveRegion$1, (0, $iunch.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $1Mpn7.createElement(SelectContainer, (0, $iunch.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $1Mpn7.createElement(Control, (0, $iunch.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $1Mpn7.createElement(ValueContainer, (0, $iunch.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $1Mpn7.createElement(IndicatorsContainer, (0, $iunch.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $bOy9g.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $c6176df7343acb0a$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $c6176df7343acb0a$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $c6176df7343acb0a$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $bOy9g.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $3lqla.default)((0, $3lqla.default)((0, $3lqla.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $1Mpn7.Component));
$c6176df7343acb0a$export$25ce5a424b770e84.defaultProps = $c6176df7343acb0a$export$407448d2b89b1813;

});
parcelRegister("hM7Tj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf0d0a66b7330526$export$2e2bcd8739ae039; });
function $cf0d0a66b7330526$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("3fnhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d4d47e9d304ab0$export$2e2bcd8739ae039; });

var $hS3oF = parcelRequire("hS3oF");
function $25d4d47e9d304ab0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $hS3oF.default)(descriptor.key), descriptor);
    }
}
function $25d4d47e9d304ab0$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $25d4d47e9d304ab0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $25d4d47e9d304ab0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("e52ho", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4034d00f0e0c32b$export$2e2bcd8739ae039; });

var $1DEZW = parcelRequire("1DEZW");
function $a4034d00f0e0c32b$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $1DEZW.default)(subClass, superClass);
}

});
parcelRegister("1DEZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13193c4e1032edd4$export$2e2bcd8739ae039; });
function $13193c4e1032edd4$export$2e2bcd8739ae039(o, p) {
    $13193c4e1032edd4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13193c4e1032edd4$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("8faVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60083302b8d1a733$export$2e2bcd8739ae039; });

var $4zDU1 = parcelRequire("4zDU1");

var $11fth = parcelRequire("11fth");

var $gjnOR = parcelRequire("gjnOR");
function $60083302b8d1a733$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $11fth.default)();
    return function _createSuperInternal() {
        var Super = (0, $4zDU1.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4zDU1.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gjnOR.default)(this, result);
    };
}

});
parcelRegister("4zDU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3549621b50cb49a5$export$2e2bcd8739ae039; });
function $3549621b50cb49a5$export$2e2bcd8739ae039(o) {
    $3549621b50cb49a5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3549621b50cb49a5$export$2e2bcd8739ae039(o);
}

});

parcelRegister("11fth", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0be1e2b3e768bae0$export$2e2bcd8739ae039; });
function $0be1e2b3e768bae0$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("gjnOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be00e5bb8356e74c$export$2e2bcd8739ae039; });

var $iVDBw = parcelRequire("iVDBw");

var $bN8hf = parcelRequire("bN8hf");
function $be00e5bb8356e74c$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $iVDBw.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bN8hf.default)(self);
}

});
parcelRegister("bN8hf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $895ab100f4375c50$export$2e2bcd8739ae039; });
function $895ab100f4375c50$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("kTtK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f36003ba0d59f0b6$export$2e2bcd8739ae039; });

var $fbQqH = parcelRequire("fbQqH");

var $6l5sL = parcelRequire("6l5sL");

var $2g8dI = parcelRequire("2g8dI");

var $idQFP = parcelRequire("idQFP");
function $f36003ba0d59f0b6$export$2e2bcd8739ae039(arr) {
    return (0, $fbQqH.default)(arr) || (0, $6l5sL.default)(arr) || (0, $2g8dI.default)(arr) || (0, $idQFP.default)();
}

});
parcelRegister("fbQqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0f08d8595ab9ba6$export$2e2bcd8739ae039; });

var $7LPtX = parcelRequire("7LPtX");
function $b0f08d8595ab9ba6$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7LPtX.default)(arr);
}

});

parcelRegister("6l5sL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d8f1116bb93b14$export$2e2bcd8739ae039; });
function $49d8f1116bb93b14$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("idQFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4424cccaf3dbe08$export$2e2bcd8739ae039; });
function $d4424cccaf3dbe08$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("OCMJz", function(module, exports) {

var $jjExS = parcelRequire("jjExS");
function $0982c186904c0763$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0982c186904c0763$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0982c186904c0763$var$ownKeys(Object(t), !0).forEach(function(r) {
            $jjExS(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0982c186904c0763$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $0982c186904c0763$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("25Lr6", function(module, exports) {

var $6pDhi = parcelRequire("6pDhi");

var $f188g = parcelRequire("f188g");

var $kcuts = parcelRequire("kcuts");
function $1860d83e44421ec5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f188g();
    return function _createSuperInternal() {
        var Super = $6pDhi(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6pDhi(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $kcuts(this, result);
    };
}
module.exports = $1860d83e44421ec5$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f188g", function(module, exports) {
function $aeed41ec2c9cee3e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $aeed41ec2c9cee3e$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




})();
//# sourceMappingURL=language-selector.4fc8842e.js.map
